<template>
<div class="form_layout">
	<div class="form_outer" style="width: 900px;">
		<div class="dialog_form_head"  v-if="this.rediskey===null" >
			产出数据预测
		</div>
		<div class="dialog_form">
      <el-form  :model="yc_data"  :rules="rules" ref="ruleForm" class="demo-ruleForm">
			<div class="dialog_head">
		        <span class="tit">产出数据预测</span>
		        <el-date-picker
		          v-model="yearAndMonth"
              readonly
		          type="month"
		          placeholder="选择月"
		          style="width:120px;">
		        </el-date-picker>
		    </div>
		    <div class="d_content">
          <div class="mg1" v-if="last_month_pm!==null">上月产值排名：{{last_month_pm}}</div>
		        <table border="0" cellspacing="0" cellpadding="0" class="table">
		          <tr>
		            <td class="td_bg" width="100px"></td>
		            <td class="td_bg">产值（万元）</td>
		            <td class="td_bg">固定资产（万元）</td>
		          </tr>
		          <tr>
		            <td class="td_bg">{{yc_data.month}}月</td>
		            <td>
		              <el-input placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="yc_data.yc_pro"></el-input>
		            </td>
		            <td>
		              <el-input placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="yc_data.yc_gdzc"></el-input>
		            </td>
		          </tr>
		          <tr>
		            <td class="td_bg">1季度</td>
		            <td>
		              <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="yc_data.q1_yc_pro"></el-input>
		            </td>
		            <td>
		              <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="yc_data.q1_yc_gdzc"></el-input>
		            </td>
		          </tr>
		          <tr>
		            <td class="td_bg">上半年</td>
		            <td>
		              <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="yc_data.byear_yc_pro"></el-input>
		            </td>
		            <td>
		              <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="yc_data.byear_yc_gdzc"></el-input>
		            </td>
		          </tr>
		          <tr>
		            <td class="td_bg">1-3季度</td>
		            <td>
		              <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="yc_data.q13_yc_pro"></el-input>
		            </td>
		            <td>
		              <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="yc_data.q13_yc_gdzc"></el-input>
		            </td>
		          </tr>
		          <tr>
		            <td class="td_bg">全年</td>
		            <td>
		              <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="yc_data.qyear_yc_pro"></el-input>
		            </td>
		            <td>
		              <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="yc_data.qyear_yc_gdzc"></el-input>
		            </td>
		          </tr>
		          <tr>
		            <td colspan="3" style="border-left: 0;border-right: 0;">企业生产情况：</td>
		          </tr>
		          <tr>
		            <td colspan="3">
                  <el-form-item  prop="scqk">
		              <el-input type="textarea" :rows="3" v-model="yc_data.scqk"></el-input>
                  </el-form-item>
		            </td>
		          </tr>
		        </table>
		        <div class="mg2">
		          注意事项：<br/>
		          1、请于每月13日前完成数据的填报；<br/>
		          2、已完成季度修改为实际产值和实际固定资产。
		        </div>
		    </div>
      </el-form>
			<div class="footer_btn">
			    <el-button type="primary" @click="handleSubmitUserSurvey(2,'ruleForm')">提 交</el-button>
			    <el-button @click="handleSubmitUserSurvey(1,'ruleForm')">暂 存</el-button>
			    <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
			</div>
		</div>
	</div>
</div>
</template>

<script>
	export default{
		name:'addsurvey',
		data(){
			return {
        rediskey:null,
				yearAndMonth:'' ,
        last_month_pm:null,
			    yc_data:{
			        year:null,
			        month:null,
			        status:null,
			        yc_pro:null,
			        yc_gdzc:null,
			        q1_yc_pro:null,
			        byear_yc_pro:null,
			        q13_yc_pro:null,
			        qyear_yc_pro:null,
			        q1_yc_gdzc:null,
			        byear_yc_gdzc:null,
			        q13_yc_gdzc:null,
			        qyear_yc_gdzc:null,
			        scqk:null
			    },
        rules: {
          scqk : [
            { min: 0, max: 600, message: '企业生产情况不能超过600字', trigger: 'blur' }
          ],
        }
			}
		},
		created(){
      let redisKey= this.$route.query.rediskey;
      if(redisKey!==undefined && redisKey!==null){
        window.localStorage.setItem("gyzhqy_token",redisKey);
        this.addData.corpid=this.$route.query.corpid;
        this.rediskey=redisKey;
      }
      this.getSurveyMonth();
		},
		methods:{
			tempStorage(){

			},
			submitAdd(){

			},
			async getSurveyMonth(){
		      let res = await this.$ajax.get(this.bUrl + 'api/portal/data/getId');
		      if(res.data.data.year!=null && res.data.data.month!=null){
//		        this.dialogVisible=true;
		        this.yearAndMonth=`${res.data.data.year}-${res.data.data.month}`;
		        this.yc_data.month=`${res.data.data.month}`;
		        this.yc_data.year=`${res.data.data.year}`;
            if(res.data.data.pm!==null) this.last_month_pm=res.data.data.pm;

		        /* 获取上月填报的*/
            let lastRes = await this.$ajax.get(this.bUrl + 'api/portal/data/lastYc');
            this.yc_data.q1_yc_pro=lastRes.data.data.q1_yc_pro;
            this.yc_data.q1_yc_gdzc=lastRes.data.data.q1_yc_gdzc;
            this.yc_data.byear_yc_pro=lastRes.data.data.byear_yc_pro;
            this.yc_data.byear_yc_gdzc=lastRes.data.data.byear_yc_gdzc;
            this.yc_data.q13_yc_pro=lastRes.data.data.q13_yc_pro;
            this.yc_data.q13_yc_gdzc=lastRes.data.data.q13_yc_gdzc;
            this.yc_data.qyear_yc_pro=lastRes.data.data.qyear_yc_pro;
            this.yc_data.qyear_yc_gdzc=lastRes.data.data.qyear_yc_gdzc;
		      }else{
		        this.$message.error("当前无法填报");
           // this.last_month_pm=10;
		      }
		    },
			async handleSubmitUserSurvey(status,formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitUserSurvey(status);
          } else {
            setTimeout(()=>{
              var isError = document.getElementsByClassName("is-error");
              console.log(isError)
              var htmlInputElement = isError[0].querySelector('input');
              if(htmlInputElement) htmlInputElement.focus();

              var htmlAreaElement = isError[0].querySelector('textarea');
              if(htmlAreaElement) htmlAreaElement.focus();
            },100);
            // alert('error submit!!');
            return false;
          }
        });
		   },

		   async submitUserSurvey(status){
         let data=this.yc_data;
         data.status=status;
         let res = await this.$ajax.post(this.bUrl + 'api/portal/data/saveYc',data);
         if(res.data.code!==200){
           this.$message.error(res.data.msg);
         }else {
           this.$message.success(res.data.msg);
           this.$emit('emitClose')
         }
       }


		}
	}
</script>

<style scoped>
	.mg1{
		margin-bottom: 10px;
	}
	.mg2{
		margin-top: 10px;
		line-height: 28px;
	}
</style>



// WEBPACK FOOTER //
// src/components/user/form/addsurvey.vue